let searchAjax = null; // Variabile per tracciare la richiesta XHR

// Seleziona tutti gli elementi necessari per la gestione dei filtri
const searchFormTogglers = document.getElementsByClassName('search-form-toggler');
const searchFormBar = document.getElementById('searchFormBar');
const filtersForm = document.getElementById('filtersForm');
const eventSearchFilter = document.getElementById('eventSearchFilter');
const eventSearchFilterBtn = document.getElementById('eventSearchFilterBtn');
const eventSearchClear = document.getElementById('eventSearchClear');
const eventCategoryFilter = document.getElementById('eventCategoryFilter');
const eventThemesFilter = document.getElementById('eventThemesFilter');
const eventLocationsFilter = document.getElementById('eventLocationsFilter');
const programDateFilters = document.querySelectorAll('.program-date-filters');

// Aggiungi un ascoltatore all'evento keyup per il campo di ricerca
if (eventSearchFilter !== null) {
	eventSearchFilter.addEventListener('keyup', function() {

		// Se c'è una richiesta XHR in corso, interrompila
		if (searchAjax !== null) {
			searchAjax.abort();
		}

		if (this.value.length > 0) {
			if(!eventSearchClear.classList.contains("show")) {
				eventSearchClear.classList.add("show")
			}
		} else {
			if(eventSearchClear.classList.contains("show")) {
				eventSearchClear.classList.remove("show")
			}
		}

		// Effettua la nuova ricerca solo se la lunghezza della stringa di ricerca è maggiore di 3
		performSearch(this.value);
	});
}

if (eventSearchFilterBtn !== null && eventSearchFilter !== null) {
	eventSearchFilterBtn.addEventListener('click', function() {

		// Se c'è una richiesta XHR in corso, interrompila
		if (searchAjax !== null) {
			searchAjax.abort();
		}

		// Effettua la nuova ricerca solo se la lunghezza della stringa di ricerca è maggiore di 3
		if (this.value.length >= 3) {
			performSearch(this.value);
		}
	});
}

if (eventSearchClear !== null && eventSearchFilter !== null) {
	eventSearchClear.addEventListener('click', function() {
		eventSearchFilter.value = '';

		if(eventSearchClear.classList.contains("show")) {
			eventSearchClear.classList.remove("show")
		}

		filtersForm.requestSubmit();
	});
}

// Aggiungi ascoltatori agli altri filtri
if (eventCategoryFilter !== null) {
	eventCategoryFilter.addEventListener('change', () => {
		filtersForm.requestSubmit();
	});
}

if (eventThemesFilter !== null) {
	eventThemesFilter.addEventListener('change', () => {
		filtersForm.requestSubmit();
	});
}

if (eventLocationsFilter !== null) {
	eventLocationsFilter.addEventListener('change', () => {
		filtersForm.requestSubmit();
	});
}

if (programDateFilters.length > 0) {

	programDateFilters.forEach((programDateFilter) => {

		programDateFilter.addEventListener('change', (e) => {

			let programDateCheck = e.target;

			if (programDateCheck.classList.contains('active')) {
				programDateCheck.classList.remove('active');
			} else {
				programDateCheck.classList.add('active');
			}

			filtersForm.requestSubmit();

		});


	});

}

// Aggiungi un ascoltatore per l'invio del modulo di filtro
if (filtersForm !== null) {
	filtersForm.addEventListener('submit', function(e) {
		e.preventDefault();
		
		const form = e.target;

		if (form.reportValidity()) {
			performSearch('');
		}
	});
}

// Funzione per eseguire la ricerca
function performSearch(searchQuery) {
	const ajaxUrl = WPURLS.ajaxUrl + '?action=' + filtersForm.getAttribute('data-action');
	const formData = new FormData(filtersForm);

	// Crea una nuova richiesta XHR
	const xhr = new XMLHttpRequest();
	xhr.open('POST', ajaxUrl, true);

	// Definisci la funzione di callback per gestire la risposta della richiesta XHR
	xhr.onload = function() {
		if (xhr.status === 200) {
			document.getElementById("results").innerHTML = xhr.responseText;
		} else {
			console.error("Errore: ", xhr.statusText);
		}

		// Aggiorna la variabile searchAjax con la nuova richiesta XHR
		searchAjax = xhr;
	};

	// Definisci la funzione di callback per gestire gli errori della richiesta XHR
	xhr.onerror = function() {
		console.error('Errore:', xhr.statusText);
	};

	// Definisci la funzione di callback per gestire il timeout della richiesta XHR
	xhr.ontimeout = function() {
		console.error('Richiesta scaduta');
	};

	// Invia la richiesta XHR con i dati del modulo di filtro
	xhr.send(formData);

	// Aggiorna la variabile searchAjax con la nuova richiesta XHR
	searchAjax = xhr;
}


for (let i = 0; i < searchFormTogglers.length; i++) {
	searchFormTogglers[i].addEventListener('click', function() {
		if (searchFormBar.classList.contains('open')) {
			searchFormBar.classList.remove('open');
		} else {
			searchFormBar.classList.add('open');
		}
	});
}